export default (number: string, message: string): string => {
  // `?&` (not just `?`) is essential for better device compatibility
  return `sms:${number}?&body=${encodeURIComponent(message)}`;
};
